/* eslint-disable*/
import React, { Component } from 'react';
import moment from 'moment';
import { DtpContentContainer, DtpAccordionGroup, DtpAccordionPanel, DtpPanel } from 'dtp-react-components';
import { Input, Button, Grid } from '../../components';
import { trataMensagensErro } from '../../utils/requests';
import Periodo from './Periodo';
import { stringToData } from '../../utils/helpers';


class CalculadoraPeriodos extends Component {  constructor(props) {
    super(props);
    this.state = {
      periodosRgps: { 
        totalAno: '',
        totalMes: '',
        totalDia: '',
        qtdTotalDias: '',
      },
      periodosRpps: {
        qtdTotalDiasCorridos: '',
        // totalAno: '',
        // totalMes: '',
        // totalDia: '',
      },
      listaPeriodos: [],
      periodo: { 
        index: 0,
        dataInicio: '',
        dataFim: '',
        totalAno: '',
        totalMes: '',
        totalDia: '',
        diasCorridos: '',
      },
    };
  }
  
  componentDidMount() {
    this.montaFormulario();
  };

  montaFormulario = () => {
    let { listaPeriodos } = { ...this.state };
    if (listaPeriodos.length === 0) {
      let periodo = {};
      periodo.index = 0;
      periodo[`dataInicio-0`] = '';
      periodo[`dataFim-0`] = '';
      periodo.totalAno = '';
      periodo.totalMes = '';
      periodo.totalDia = '';
      periodo.diasCorridos = '';
      periodo.calculado = false;

      listaPeriodos.push(periodo);
      this.setState({ listaPeriodos });
    }
  };

  handleChangeDate = (obj, name) => {
    this.setState({
      [name]: obj.value,
    });
  };

  verificarPreenchimentoPeriodos = () => {
    const { listaPeriodos } = { ...this.state };
    let retorno = false;
    listaPeriodos.forEach((periodo) => {  
      if (!(periodo.calculado)) {
        retorno = true;
      }
    });
    return retorno;
  };

  criarPeriodoVazio = (indice) => {
    let retorno = {};
    retorno.index = indice;
    retorno[`dataInicio-${indice}`] = '';
    retorno[`dataFim-${indice}`] = '';
    retorno.totalAno= '';
    retorno.totalMes = '';
    retorno.totalDia = '';
    retorno.diasCorridos = '';
    retorno.calculado = false;

    return retorno;
  };
   
  validarRegrasPeriodo = () => {
    let { listaPeriodos } = { ...this.state };

    listaPeriodos.forEach((periodo) => {
      let possuiDataInicio = this.state[`dataInicio-${periodo.index}`] !== undefined && this.state[`dataInicio-${periodo.index}`] !== null  && 
                             this.state[`dataInicio-${periodo.index}`] !== '' && !(this.state[`dataInicio-${periodo.index}`].includes('_'));

      let possuiDataFim = this.state[`dataFim-${periodo.index}`] !== undefined && this.state[`dataFim-${periodo.index}`] !== null && 
                          this.state[`dataFim-${periodo.index}`] !== '' && !(this.state[`dataFim-${periodo.index}`].includes('_'));
     
      if (possuiDataInicio && possuiDataFim) {
        periodo[`dataInicio-${periodo.index}`] = this.state[`dataInicio-${periodo.index}`];
        periodo[`dataFim-${periodo.index}`] = this.state[`dataFim-${periodo.index}`];      

        const mesFev = 2;
        const ultimoDiaFevBissexto = 29;
        let diaDataInicio = Number(periodo[`dataInicio-${periodo.index}`].split('/')[0]);
        let mesDataInicio = Number(periodo[`dataInicio-${periodo.index}`].split('/')[1]);
        let anoInicioBissexto = moment(periodo[`dataInicio-${periodo.index}`], 'DD/MM/YYYY').isLeapYear();

        let diaDataFim = Number(periodo[`dataFim-${periodo.index}`].split('/')[0]);
        let mesDataFim= Number(periodo[`dataFim-${periodo.index}`].split('/')[1]);
        let anoFimBissexto = moment(periodo[`dataFim-${periodo.index}`], 'DD/MM/YYYY').isLeapYear();

        if (!(anoInicioBissexto) && mesDataInicio === mesFev && diaDataInicio === ultimoDiaFevBissexto ||
          !(anoFimBissexto) && mesDataFim === mesFev && diaDataFim === ultimoDiaFevBissexto) {
          trataMensagensErro(['A Data Início ou Data Fim não corresponde a ano Bissexto']); 
          this.limparInputDataAmd(periodo);
        } else {  
          let dataInicioCompleto = moment(periodo[`dataInicio-${periodo.index}`], 'DD/MM/YYYY'); 
          let dataFimCompleto = moment(periodo[`dataFim-${periodo.index}`], 'DD/MM/YYYY');

          if (dataFimCompleto.isSameOrAfter(dataInicioCompleto)) {     
            const temConcomitancia = this.verificarConcomitancias(listaPeriodos, periodo.index );

            if (temConcomitancia) {
              trataMensagensErro([`O Período de ${periodo[`dataInicio-${periodo.index}`]} até ${periodo[`dataFim-${periodo.index}`]} é concomitante com outros períodos existentes na lista.`]);    
              this.limparInputDataAmd(periodo);
              this.verificarPreenchimentoPeriodos(); 
            } else {  
              periodo.calculado = true;       
              periodo = this.handleCalcularAmd(periodo);
              periodo = this.handleCalcularDiasCorridos(periodo); 
            }  

          } else {
            trataMensagensErro(['A Data de Início deve ser menor que a Data de Fim.']);
            this.limparInputDataAmd(periodo);
            this.verificarPreenchimentoPeriodos();
          }  
        }   
        this.limparInputFormulas();   
        
      } else {
        this.limparInputDataAmd(periodo);
      }  
    });
    this.setState({
      listaPeriodos,
    });
  };

  verificarConcomitancias = (lista, index ) => {
    let { listaPeriodos } = {...this.state};
    let periodoAtual = 0;
    listaPeriodos.forEach((periodo, arrayIndex) => {
      if (index === periodo.index) {
        index = arrayIndex;
        periodoAtual = lista[arrayIndex];
      }
    });

    for (let i = 0, tamanhoI = lista.length; i < tamanhoI; i += 1)  {
      if (index != i  ) {
        let periodoAux = lista[i];
        if ((stringToData(periodoAtual[`dataInicio-${periodoAtual.index}`])) <= stringToData((periodoAux[`dataFim-${periodoAux.index}`])) &&
          stringToData((periodoAux[`dataInicio-${periodoAux.index}`])) <=  stringToData((periodoAtual[`dataFim-${periodoAtual.index}`]))) {
          return true ;
        }        
      }
    };
    return false;
  };

  handleAdicionarPeriodo = () => {
    let { listaPeriodos } = { ...this.state };
    listaPeriodos.forEach((periodo) => {
      listaPeriodos.push(this.criarPeriodoVazio(periodo.index+1));
      listaPeriodos = this.reorganizarIndiceLista(this.ordenarListaPeriodos(listaPeriodos)); 
       
      this.setState({
        listaPeriodos,
      }, this.reorganizarInputData(listaPeriodos));
    });
    this.limparInputFormulas();
  };
  
  reorganizarIndiceLista = () => {
    let { listaPeriodos } = { ...this.state };
    let listaIndiceCorrigido = [];
    
    listaPeriodos.forEach((periodo, arrayIndex) => {
      let retorno = {};
      if (periodo.index === arrayIndex) {
        retorno.index = periodo.index;
        retorno[`dataInicio-${arrayIndex}`] = periodo[`dataInicio-${arrayIndex}`];
        retorno[`dataFim-${arrayIndex}`] = periodo[`dataFim-${arrayIndex}`];
        retorno.totalAno= periodo.totalAno;
        retorno.totalMes = periodo.totalMes;
        retorno.totalDia = periodo.totalDia;
        retorno.diasCorridos = periodo.diasCorridos;
        retorno.calculado = periodo.calculado;
      } else {
        retorno.index = arrayIndex;
        retorno[`dataInicio-${arrayIndex}`] = periodo[`dataInicio-${periodo.index}`];
        retorno[`dataFim-${arrayIndex}`] = periodo[`dataFim-${periodo.index}`];
        retorno.totalAno= periodo.totalAno;
        retorno.totalMes = periodo.totalMes;
        retorno.totalDia = periodo.totalDia;
        retorno.diasCorridos = periodo.diasCorridos;
        retorno.calculado = periodo.calculado;
      }
      listaIndiceCorrigido.push(retorno);
    });
    return listaIndiceCorrigido;
  };

  reorganizarInputData = (lista) => {
    lista.forEach((periodo, arrayIndex) => {
      this.setState({
        [`dataInicio-${arrayIndex}`] : periodo[`dataInicio-${arrayIndex}`],
        [`dataFim-${arrayIndex}`] : periodo[`dataFim-${arrayIndex}`]
      });
    });
  };

  handleRemoverPeriodo = (indice) => {
    let { listaPeriodos } = { ...this.state };
    listaPeriodos.forEach((periodo, arrayIndex) => {
      if (periodo.index === indice) {
        listaPeriodos.splice(arrayIndex, 1);  
      }
    });
    listaPeriodos = this.reorganizarIndiceLista(this.ordenarListaPeriodos(listaPeriodos)); 

    this.setState({
      listaPeriodos,
    }, this.reorganizarInputData(listaPeriodos));
    
    this.limparInputFormulas(); 
  };

  compararDatasInicio = (a, b) => {
    if (moment(a[`dataInicio-${a.index}`], 'DD/MM/YYYY').toDate() < moment(b[`dataInicio-${b.index}`], 'DD/MM/YYYY').toDate()) {
      return -1;
    }
    if (moment(a[`dataInicio-${a.index}`], 'DD/MM/YYYY').toDate() > moment(b[`dataInicio-${b.index}`], 'DD/MM/YYYY').toDate()) {
      return 1;
    }
    return 0;
  };

  ordenarListaPeriodos = (lista) => {
    return lista.sort(this.compararDatasInicio);
  };

  handleCalcularAmd = (periodo) => {
    const acrescentarDia = 1;
    const acrescentarMesDias = 30;
    const trintaUm = 31;
    const qtdDiasMes = 30;
    const qtdMesesAno = 12;
    const acrescentarAno = 12;
    const reduzirMes = 1;
    const reduzirAno = 1;
    const mesFev = 2;
    const ultimoDiaFevBissexto = 29;
    const ultimoDiaFevNaoBissexto = 28;

    let resultadoDia = 0;
    let resultadoMes = 0;
    let resultadoAno = 0;

    let resultadoQtdMeses = 0;
    let restoDivisaoDia = 0;
    let resultadoQtdAnos = 0;
    let restoDivisaoMes = 0;

    let diaInicio = periodo[`dataInicio-${periodo.index}`].split('/')[0];
    let mesInicio = periodo[`dataInicio-${periodo.index}`].split('/')[1];
    let anoInicio = periodo[`dataInicio-${periodo.index}`].split('/')[2];

    let diaFim = periodo[`dataFim-${periodo.index}`].split('/')[0];
    let mesFim = periodo[`dataFim-${periodo.index}`].split('/')[1];
    let anoFim = periodo[`dataFim-${periodo.index}`].split('/')[2];

   
    if (moment([anoFim]).isLeapYear()) {
      if (Number(mesFim) === mesFev && Number(diaFim) === ultimoDiaFevBissexto) {
        diaFim = Number(diaFim) + 1;
      }   
    } else {
      if (Number(mesFim) === mesFev && Number(diaFim) === ultimoDiaFevNaoBissexto) {
        diaFim = Number(diaFim) + 2;
      }
    }
    
    if (Number(diaFim) < trintaUm) {
      diaFim = Number(diaFim) + acrescentarDia;
      if (Number(diaInicio > diaFim)) {
        diaFim = Number(diaFim) + acrescentarMesDias;
        mesFim = Number(mesFim) - reduzirMes;
      }
    }
    resultadoDia = Number(diaFim - diaInicio);

    resultadoQtdMeses = Math.trunc(resultadoDia / qtdDiasMes);
    restoDivisaoDia = (resultadoDia % qtdDiasMes);
    resultadoDia = restoDivisaoDia;

    if(Number(mesFim < mesInicio)) {
      mesFim = Number(mesFim) + acrescentarAno;
      anoFim = Number(anoFim) - reduzirAno;
    }
    resultadoMes = Number(mesFim - mesInicio);
    resultadoMes += resultadoQtdMeses;

    resultadoQtdAnos = Math.trunc(resultadoMes / qtdMesesAno);
    restoDivisaoMes = (resultadoMes % qtdMesesAno);
    resultadoMes = restoDivisaoMes;  

    resultadoAno = Number(anoFim - anoInicio);
    resultadoAno += resultadoQtdAnos;

    periodo.totalAno = Math.trunc((Number(resultadoAno)));
    periodo.totalMes = Math.trunc((Number(resultadoMes)));
    periodo.totalDia = Math.trunc((Number(resultadoDia)));

    return periodo; 
  };

  limparInputDataAmd = (periodo) => {
    periodo[`dataInicio-${periodo.index}`] = '';
    periodo[`dataFim-${periodo.index}`] = ''; 
    periodo.totalAno = '';
    periodo.totalMes = '';
    periodo.totalDia = '';
    periodo.diasCorridos = '';
    periodo.calculado = false;

    return periodo;
  };

  handleCalcularDiasCorridos = (periodo) => {  
    let retorno = periodo;  
    let dataInicioCorrido = moment(periodo[`dataInicio-${periodo.index}`], 'DD/MM/YYYY'); 
    let dataFimCorrido = moment(periodo[`dataFim-${periodo.index}`], 'DD/MM/YYYY');

    const acrescentarDataFinal = 1;
  
    let diffDatas = (dataFimCorrido.diff(dataInicioCorrido, 'days')) + acrescentarDataFinal;      
    retorno.diasCorridos = diffDatas;
    
    return retorno;
  };

  handleCalcularRgps = () => {
    let { periodosRgps } = { ...this.state };
    let { listaPeriodos } = { ...this.state };

    let resultadoDia = 0;
    let resultadoMes = 0;
    let resultadoAno = 0;

    let resultadoQtdMeses = 0;
    let restoDivisaoDia = 0;
    let resultadoQtdAnos = 0;
    let restoDivisaoMes = 0;
   
    const acrescentarMesDias = 30;
    const qtdDiasMes = 30;
    const qtdMesesAno = 12; 
    const acrescentarAnoDias = 365

    listaPeriodos.forEach((periodo) => {
      if (periodo.totalDia !== '' && periodo.totalMes !== '' && periodo.totalAno !== '') { 

        resultadoDia += periodo.totalDia;
        resultadoQtdMeses = Math.trunc(resultadoDia / qtdDiasMes);
        restoDivisaoDia = (resultadoDia % qtdDiasMes);
        resultadoDia = restoDivisaoDia;
      
        resultadoMes += periodo.totalMes + resultadoQtdMeses;
        resultadoQtdAnos = Math.trunc(resultadoMes / qtdMesesAno);
        restoDivisaoMes = (resultadoMes % qtdMesesAno);
        resultadoMes = restoDivisaoMes;

        resultadoAno += periodo.totalAno + resultadoQtdAnos;
      }
    });
      periodosRgps.totalDia = resultadoDia;
      periodosRgps.totalMes = resultadoMes;
      periodosRgps.totalAno = resultadoAno;
      periodosRgps.qtdTotalDias = Number((resultadoAno * acrescentarAnoDias) + (resultadoMes * acrescentarMesDias) + resultadoDia);
      
      this.setState({
        periodosRgps: { ...this.state.periodosRgps, periodosRgps },
      });
  };

  handleCalcularRpps = () => {
    let { listaPeriodos } = { ...this.state };
    let { periodosRpps } = { ...this.state }; 

    let resultadoDiasCorridos = 0;
    // let resultadoAno = 0;
    // let resultadoMes = 0;
    // let resultadoDia = 0;
    // let restoDivisaoAno = 0;
   
    // const umAno = 365;
    // const umMes = 30;

    listaPeriodos.forEach((periodo) => {
      if (periodo.diasCorridos !== '') {  
        resultadoDiasCorridos += periodo.diasCorridos;
      }
    }); 
    
    // if (resultadoDiasCorridos >= umAno) {
    //   resultadoAno = Math.trunc(resultadoDiasCorridos / umAno);
    //   restoDivisaoAno = (resultadoDiasCorridos % umAno);

    //   if (restoDivisaoAno >= umMes) {
    //     resultadoMes = Math.trunc(restoDivisaoAno / umMes);
    //     resultadoDia = (restoDivisaoAno % umMes);
    //   } else {
    //     resultadoDia = restoDivisaoAno;
    //   }
    // } else {
    //   if (resultadoDiasCorridos >= umMes) {
    //     resultadoMes = Math.trunc(resultadoDiasCorridos / umMes);
    //     resultadoDia = (resultadoDiasCorridos % umMes);

    //   } else {
    //     resultadoDia = resultadoDiasCorridos;
    //   }
    // }

    periodosRpps.qtdTotalDiasCorridos = resultadoDiasCorridos;
    // periodosRpps.totalAno = resultadoAno;
    // periodosRpps.totalMes = resultadoMes;
    // periodosRpps.totalDia = resultadoDia;
    
    this.setState({
      periodosRpps: { ...this.state.periodosRpps, periodosRpps },
    });   
  };

  verificarPeriodoAdicionado = () => {
    const { listaPeriodos } = { ...this.state };
    let retorno = false;
    
    let possuiPeriodo = listaPeriodos.some((periodo) => 
    periodo[`dataInicio-${periodo.index}`] !== '' && periodo[`dataInicio-${periodo.index}`] !== null &&  
    periodo[`dataFim-${periodo.index}`] !== '' && periodo[`dataFim-${periodo.index}`] !== null && 
    !(periodo[`dataInicio-${periodo.index}`].includes('_')) && !(periodo[`dataFim-${periodo.index}`].includes('_')));

    if (possuiPeriodo) {
      retorno = true;
        return;
    } else {
      retorno = true;
    }
    return retorno;
  };

  handleCalcularTodosPeriodos = () => {     
    this.handleCalcularRgps();
    this.handleCalcularRpps();
  };

  handleLimparTodosPeriodos = () => {
    let { listaPeriodos, periodosRgps, periodosRpps } = { ...this.state };

    listaPeriodos.forEach((periodo) => {
      this.setState({
        [`dataInicio-${periodo.index}`] : '',
        [`dataFim-${periodo.index}`] : '',
      });
    });

    listaPeriodos = [];
    periodosRgps = {};
    periodosRpps = {};

    this.setState({
      listaPeriodos,
      periodosRgps,
      periodosRpps,
    }, this.montaFormulario);
  };
  
  limparInputFormulas = () => {
    let { periodosRgps } = { ...this.state };
    let { periodosRpps } = { ...this.state }; 

    periodosRgps.totalDia = '';
    periodosRgps.totalMes = '';
    periodosRgps.totalAno = '';
    periodosRgps.qtdTotalDias = '';

    periodosRpps.qtdTotalDiasCorridos = '';
    // periodosRpps.totalAno = '';
    // periodosRpps.totalMes = '';
    // periodosRpps.totalDia = '';
    
    this.setState({
      periodosRgps: { ...this.state.periodosRgps, periodosRgps },
      periodosRpps: { ...this.state.periodosRpps, periodosRpps },
    });
  };
  
  render() {
    let { listaPeriodos } = { ...this.state }
    let colecao = [];
    listaPeriodos.forEach((periodo) => {
      colecao.push(
        <React.Fragment>
          <Periodo
            state = {this.state}         
            periodo = {periodo}
            listaPeriodos = {this.state.listaPeriodos}
            changePeriodo = {this.handleChangeDate}
            validarRegras = {this.validarRegrasPeriodo}
            verificarPreenchimentoPeriodos = {this.verificarPreenchimentoPeriodos}
            adicionarPeriodo = {this.handleAdicionarPeriodo}
            removerPeriodo = {this.handleRemoverPeriodo}
            displayButton = {true}
            disabledInputDate = {false}
          />
        </React.Fragment>
      )
      return colecao;
    });
  
    return (
      <DtpContentContainer>
        <DtpAccordionGroup>
          <DtpAccordionPanel
            headingId="CalculadoraPeriodos"
            panelId="calculadora-periodos"
            icon="ico-calc"
            title="Calculadora de Períodos"
          >
            {colecao}
            <div className="row">
              <Grid cols="row"> 
                <div className='right'>            
                  <Button
                    className="dtp-btn"
                    title="Limpar"
                    hint="Limpar"
                    onClick={() => this.handleLimparTodosPeriodos()}
                  />
                  <Button
                    className="dtp-primary"
                    title="Calcular"
                    hint="Calcular Períodos"
                    disabled={this.verificarPeriodoAdicionado()}
                    onClick={() => this.handleCalcularTodosPeriodos()}
                  />  
                </div>
              </Grid>
            </div>
            <DtpPanel title="Fórmula do RGPS">
              <div className="row">
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Anos"
                    integer
                    disabled
                    value={this.state.periodosRgps.totalAno}
                  />
                </Grid>
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Meses"
                    integer
                    disabled
                    value={this.state.periodosRgps.totalMes}
                  />
                </Grid>
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Dia"
                    integer
                    disabled
                    value={this.state.periodosRgps.totalDia}
                  />
                </Grid>
                <Grid cols="1 1 1 1">
                  <Input disabled value="|" style={{ borderBottom: 'none', 'text-align': 'center' }} />
                </Grid>
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Dias"
                    disabled
                    value={this.state.periodosRgps.qtdTotalDias}
                  />
                </Grid>
              </div>
            </DtpPanel>
            <DtpPanel title="Fórmula do RPPS">
              <div className="row">         
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Dias"
                    disabled
                    value={this.state.periodosRpps.qtdTotalDiasCorridos}
                  />
                </Grid>
                {/* <Grid cols="1 1 1 1">
                  <Input disabled value="|" style={{ borderBottom: 'none', 'text-align': 'center' }} />
                </Grid>
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Anos"
                    integer
                    disabled
                    value={this.state.periodosRpps.totalAno}
                  />
                </Grid>
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Meses"
                    integer
                    disabled
                    value={this.state.periodosRpps.totalMes}
                  />
                </Grid>
                <Grid cols="2 2 2 2">
                  <Input
                    showMask={false}
                    label="Dia"
                    integer
                    disabled
                    value={this.state.periodosRpps.totalDia}
                  />
                </Grid> */}
              </div>
            </DtpPanel>
          </DtpAccordionPanel>
        </DtpAccordionGroup>
      </DtpContentContainer>
    );
  }
}

CalculadoraPeriodos.propTypes = { };

export default CalculadoraPeriodos;



// WEBPACK FOOTER //
// ./src/pages/calculadora-periodos/CalculadoraPeriodos.jsx